import { Animations } from "../../../../../../../util/Animations";
import { StakeholderEmails } from "./StakeholderEmails_view";

export const STAKEHOLDER_EMAILS_MODAL_CONFIG = (itemIds: number[], projectId: number) => {
  return {
    showClose: true,
    title: null,
    content: <StakeholderEmails itemIds={itemIds} projectId={projectId} />,
    componentProps: {
      wrapHeight: "default",
      wrapWidth: "large",
      position: "middle",
      className: "modal__process-template"
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_UP,
      animateOut: Animations.SLIDE_OUT_DOWN
    }
  };
};
